<template>
  <div class="fold">
    <div class="logo"><img src="~assets/common/logo-default.png"/></div>
    <div class="wrapper">
      <el-collapse v-model="activeOut" accordion>
        <el-collapse-item :title='$t("main.nav[0].title")' name="1" class="outside">
          <el-collapse v-model="activeIn" accordion class="inside" >
            <el-collapse-item :title='$t("main.nav[0].list[0].title")' name="1">
              <ul>
                <li class="mt5"><router-link to="/main/hpdf">{{$t("main.nav[0].list[0].item6")}}</router-link></li>
                <li><router-link to="/main/fsdf">{{$t("main.nav[0].list[0].item1")}}</router-link></li>
                <li><router-link to="/main/gzdh">{{$t("main.nav[0].list[0].item2")}}</router-link></li>
                <li><router-link to="/main/gzdf">{{$t("main.nav[0].list[0].item3")}}</router-link></li>
                <li><router-link to="/main/cdyqc">{{$t("main.nav[0].list[0].item4")}}</router-link></li>
                <li><router-link to="/main/jmjtw">{{$t("main.nav[0].list[0].item5")}}</router-link></li>
              </ul>
            </el-collapse-item>
            <el-collapse-item :title='$t("main.nav[0].list[1].title")' name="2">
              <ul>
                <li><router-link to="/main/szbabhjh">{{$t("main.nav[0].list[1].item10")}}</router-link></li>
                <li @click="scrollGz1" class="mt5"><router-link to="/main/team1">{{$t("main.nav[0].list[1].item8")}}</router-link></li>
                <li @click="scrollGz2"><router-link to="/main/team1">{{$t("main.nav[0].list[1].item2")}}</router-link></li>
                <li @click="scrollGz3"><router-link to="/main/team1">{{$t("main.nav[0].list[1].item3")}}</router-link></li>
                <li><router-link to="/main/teamfs">{{$t("main.nav[0].list[1].item9")}}</router-link></li>
                <li><router-link to="/main/teamzh">{{$t("main.nav[0].list[1].item1")}}</router-link></li>
                <li @click="scrollSz1"><router-link to="/main/team2">{{$t("main.nav[0].list[1].item4")}}</router-link></li>
                <li @click="scrollSz2"><router-link to="/main/team2">{{$t("main.nav[0].list[1].item5")}}</router-link></li>
                <li @click="scrollCd1"><router-link to="/main/team3">{{$t("main.nav[0].list[1].item6")}}</router-link></li>
                <li @click="scrollCd2"><router-link to="/main/team3">{{$t("main.nav[0].list[1].item7")}}</router-link></li>
              </ul>
            </el-collapse-item>
          </el-collapse>
        </el-collapse-item>
        <el-collapse-item :title='$t("main.nav[1].title")' name="2">
          <ul>
            <li><router-link to="/main/hotel">{{$t("main.nav[1].list[0].item1")}}</router-link></li>
          </ul>
        </el-collapse-item>
        <el-collapse-item :title='$t("main.nav[2].title")' name="3">
          <ul>
            <li><router-link to="/main/market">{{$t("main.nav[2].list[0].item1")}}</router-link></li>
          </ul>
        </el-collapse-item>
        <el-collapse-item :title='$t("main.nav[3].title")' name="4">
          <ul>
            <li><router-link to="/main/property">{{$t("main.nav[3].list[0].item1")}}</router-link></li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fold',
  data () {
    return {
      activeOut: '1',
      activeIn: '1'
    }
  },
  mounted () {
    this.setFold()
  },
  computed: {
  },
  methods: {
    // 子标签是否活动状态
    itemIsActive (path) {
      return path === this.$route.path ? 'li-active' : ''
    },

    scrollGz1 () {
      document.querySelector('#gz1').scrollIntoView(true)
    },
    scrollGz2 () {
      document.querySelector('#gz2').scrollIntoView(true)
    },
    scrollGz3 () {
      document.querySelector('#gz3').scrollIntoView(true)
    },
    scrollSz1 () {
      document.querySelector('#sz1').scrollIntoView(true)
    },
    scrollSz2 () {
      document.querySelector('#sz2').scrollIntoView(true)
    },
    scrollCd1 () {
      document.querySelector('#cd1').scrollIntoView(true)
    },
    scrollCd2 () {
      document.querySelector('#cd2').scrollIntoView(true)
    },
    setFold () {
      let routePath = this.$route.path
      this.activeOut = '1'
      this.activeIn = '1'
      if (
        routePath === '/main/team1' || routePath === '/main/team2' ||
        routePath === '/main/team3' || routePath === '/main/teamfs' ||
        routePath === '/main/teamzh' || routePath === '/main/szbabhjh') {
        this.activeIn = '2'
      }
      else if (routePath === '/main/hotel') this.activeOut = '2'
      else if (routePath === '/main/market') this.activeOut = '3'
      else if (routePath === '/main/property') this.activeOut = '4'
    }
  },
  watch: {
    activeIn: {
      immediate: true,
      deep: true,
      handler (val) {
        console.log(val)
        console.log('route: ', this.$route.path)
      }
    },
    $route: function (to, from) {
      this.setFold()
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .fold
    width 18%
    height 500px
    background #FFF
    ul
      background #f9fafa
      text-indent 30px
    li
      cursor pointer
      line-height 28px
    li:hover
      background #eeeeee
    a
      display block
    .wrapper
      margin-top 39px
      .mt5
        mt5()
</style>



// WEBPACK FOOTER //
// src/pages/main/components/Fold.vue